export class PlaceholderParser {
    constructor(body, preserveTokens) {
        this.body = body;
        this.preserveTokens = preserveTokens;
    }
    getBody() {
        return this.body ?? "";
    }
    getDefaultTokenValues() {
        const matches = this.getBody().match(/{{\s*([^|}]+)\s*\|\s*([^}]+)\s*}}/g);
        if (!matches) {
            return [];
        }
        return matches.map(match => {
            const [token, defaultValue] = match
                .replace(/{{\s*/, "")
                .replace(/\s*}}/, "")
                .split("|")
                .map(x => x.trim());
            return { key: token, fallback: defaultValue };
        });
    }
    apply(replacementValues) {
        let result = this.getBody();
        const defaultValues = this.getDefaultTokenValues();
        for (const [key, value] of Object.entries(replacementValues)) {
            const matchingDefaultValues = defaultValues.filter(x => x.key === key);
            for (const { key, fallback } of matchingDefaultValues) {
                result = result.replace(this.buildFallbackMatchRegex(key, fallback), value || fallback);
            }
            result = result.replace(this.buildMatchRegex(key), value);
        }
        for (const { key, fallback } of defaultValues) {
            if (this.preserveTokens && this.preserveTokens.some(p => key.startsWith(p))) {
                continue;
            }
            result = result.replace(this.buildFallbackMatchRegex(key, fallback), fallback);
        }
        return result;
    }
    get keys() {
        const matches = this.getBody().match(/{{([^}]+)}}/g);
        if (!matches) {
            return [];
        }
        const result = new Set();
        matches.forEach(match => {
            const contents = match.replace(/{{\s*/, "").replace(/\s*}}/, "");
            const [key, _] = contents.split("|").map(x => x.trim());
            result.add(key);
        });
        return Array.from(result);
    }
    buildMatchRegex(token) {
        const escapedToken = this.escapeRegexCharacters(token);
        return new RegExp(`{{\\s*${escapedToken}\\s*([|]\\s*[^}]*\\s*)?\\s*}}`, "g");
    }
    buildFallbackMatchRegex(token, fallback) {
        const escapedToken = this.escapeRegexCharacters(token);
        const escapedFallback = this.escapeRegexCharacters(fallback);
        return new RegExp(`{{\\s*${escapedToken}\\s*\\|\\s*${escapedFallback}\\s*}}`, "g");
    }
    escapeRegexCharacters(text) {
        return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
}
//# sourceMappingURL=placeholder-parser.js.map